import Api from './Api';
import store from '../store/configureStore';

class Customer {
    callbacks = [];
    customers = [];
    search = "";

    set(customer) {
    }

    subscribe(callback, tag = '') {
        this.callbacks.push({ key: tag, value: callback });
    }

    updateSubscribers(tag = '') {
        this.callbacks.forEach(cb => {
            if (!tag || !cb.key || cb.key === tag) {
                cb.value();
            }
        });
    }

    
    customersInFlight = null;
    preferencesInFlight = { };
    cachedPreferences = new Map();
  
    fetchCustomers = async () => {
        if (this.customersInFlight) return this.customersInFlight;
        this.customersInFlight = Api.fetch(`/api/user/customerList`)
              .finally(() => { this.customersInFlight = null; });
        return this.customersInFlight;
    }


    lookupCustomerPreferences(customer) {
        const key = `${customer.externalId}|${customer.companyCode}`;
        if (this.cachedPreferences.has(key)) return Promise.resolve(this.cachedPreferences.get(key));
        if (this.preferencesInFlight[key]) return this.preferencesInFlight[key];
        const body = JSON.stringify({
            externalId: customer.externalId,
            territoryCode: "",
            companyCode: customer.companyCode
        });
        this.preferencesInFlight[key] = Api.fetch(`/api/customer/customerpreferences`, {
            method: 'POST', body: body
        })
        .then(res => (res ? res.json() : null))
        .then(data => { this.cachedPreferences.set(key, data); return data; })
        .finally(() => { delete this.preferencesInFlight[key]; });
        return this.preferencesInFlight[key];
    }

    getPaymentTerms(storefrontNumber, brandCode) {
        return Api.fetch('/api/customer/paymentTerms/' + storefrontNumber + '/' + brandCode , {method: 'GET'}).then((result) => {
            if (result) {
                return result;
            } else {
                return [];
            }
        });
    }

    handleSubmitOrderResponse(res) {
        if (res)
            return res.json();
    }

    storedSelectedCustomer() {
        const selectedCustomerId = store.getState().user.currentUser.selectedCustomerId;
        const customerList = store.getState().user.customers;
        const selectedCustomer = customerList.find(customer => customer.id === selectedCustomerId)

        if (selectedCustomer && this.isValidCustomer(selectedCustomer)) {
            return selectedCustomer;
        }

        return null;
    }

    isValidCustomer(customer) {
        return customer && (customer !== "undefined") && this.customerExistsInCustomers(customer);
    }

    getSelectedCustomer() {
        return store.getState().user.selectedCustomer;
    }

    customerExistsInCustomers(customer) {

        const custList = store.getState().user.customers;
        if (custList.filter(c => c.externalId === customer.externalId).length > 0)
            return true;
        for (var i = 0; i < custList.length - 1; i++) {
            if (custList[i].children && custList[i].children.filter(c => c.externalId === customer.externalId).length > 0)
                return true;
        }
        return false;
    }

    updateSearch = (value) => {
        this.search = value;
        this.fetchCustomers();
    }

    handleError = () => {
        console.log("Failed to load customers.")
    }

    checkCreditHold = (customer) => {
        /* Comment until Latin America business requires credit hold warning
        if (customer.creditHold > 0) {
            return true;
        }*/
        return false;
    }
    get12MonthSales = async (shipTo) => {
        return Api.fetch(`/api/account/sales/${shipTo}`);
    }
    getSalesByCategory = (fromDate, toDate, territoryCode, comapnyCode, customerId, callback) => {
        let data = {
            FromDate: fromDate,
            ToDate: toDate,
            TerritoryCode: territoryCode || null,
            CompanyCode: comapnyCode || null,
            CustomerId: customerId || null
        };
        return Api.fetch(`/api/account/salesByCategory`, { method: 'POST', body: JSON.stringify(data) })
        .then((res) => {
            if (res)
                return res.json()
            })
        .then(callback);
    }
    getCustomersByTerritory = (territoryCode, companyCode, customerId, callback) => {
        let data = {
            TerritoryCode: territoryCode || null,
            CompanyCode: companyCode || null,
            CustomerId: customerId || null
        };
        return Api.fetch(`/api/account/customersByTerritory`, { method: 'POST', body: JSON.stringify(data) })
            .then((res) => {
                if (res)
                    return res.json()
            })
            .then(callback);
    }
    getSalesByCompany = (fromDate, toDate, customerId, callback) => {
        let data = {
            FromDate: fromDate,
            ToDate: toDate,
            CompanyCode: null,
            CustomerId: (customerId === undefined || customerId === null) ? null : customerId
        };
        return Api.fetch(`/api/account/salesByCompany`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(data) })
            .then((res) => {
                if (!res.ok) {
                    return [];
                }
                return res.json();
            })
            .then(callback);
    }
}

export default new Customer();
